<template>
  <div class="identity-container" :class="{ margin }">
    <InfoModal
      v-if="confirmModalVisible"
      :is-warning="true"
      title="Bekräfta skyddad identitet"
      confirm-label="Jag förstår"
      abort-label="Avbryt"
      :disable-outside-click="true"
      :show-close-btn="false"
      @click="modalClick"
    >
      <p>
        <strong>Har du skyddade personuppgifter?</strong> Vi kommer att granska
        att du har skyddade personuppgifter enligt svensk lagstiftning.
        <u>Endast om vi kan verifiera detta</u> (t.ex. via familjebevis) döljs
        ditt personnummer för andra parter och hyresvärden informeras om att du
        har skyddade personuppgifter.
      </p>
    </InfoModal>

    <Checkbox
      :is-disabled="isDisabled"
      :checked="protectedIdentityVal"
      :name="`tenant-protectedIdentity-${activeIndex}`"
      :click-mode="true"
      @click="onCheckboxChange"
    >
      Denna person har skyddad identitet
    </Checkbox>

    <InfoButtonModal title="Skyddad identitet">
      <p>
        Om du har skyddade personuppgifter behöver du fylla i vårt formulär som
        vanligt. Efter att vi har mottagit ditt personbevis kommer vi att dölja
        ditt personnummer för övriga parter. Vi uppmärksammar även hyresvärden
        om att du har skyddade personuppgifter.
      </p>
    </InfoButtonModal>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox.vue';
import InfoButtonModal from '@/components/InfoButtonModal.vue';
import InfoModal from '@/components/InfoModal.vue';

export default {
  name: 'ProtectedIdentityToggle',
  components: {
    Checkbox,
    InfoButtonModal,
    InfoModal
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    protectedIdentityVal: {
      type: Boolean,
      required: true
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    margin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      confirmModalVisible: false,
      pendingValue: null
    };
  },
  methods: {
    modalClick(event) {
      if (event === 'CONFIRM') {
        this.onConfirmOk();
      } else {
        this.onConfirmAbort();
      }
    },
    onCheckboxChange() {
      if (this.isDisabled) {
        return;
      }
      const current = !!this.protectedIdentityVal;
      const nextValue = !current;

      if (!current && nextValue) {
        this.pendingValue = true;
        this.confirmModalVisible = true;
        return;
      }
      this.emitUpdate(false);
    },
    onConfirmOk() {
      if (this.pendingValue === true) {
        this.emitUpdate(true);
      }
      this.resetConfirm();
    },
    onConfirmAbort() {
      this.emitUpdate(false);
      this.resetConfirm();
    },
    resetConfirm() {
      this.confirmModalVisible = false;
      this.pendingValue = null;
    },
    emitUpdate(value) {
      this.$emit('update', value);
    }
  }
};
</script>

<style scoped>
.identity-container {
  display: flex;
  align-items: center;
}
.identity-container.margin {
  margin-bottom: 4.8rem;
}
.identity-container > * {
  margin-bottom: 0;
}
</style>
